import { colors, cx } from '@vizit/theme';

const FALLBACK_COLOR = colors['gray-utility']['300'];

export interface ProductCategoryColorSquareProps {
  /**
   * The category's label color; a neutral gray without one
   *
   * @optional
   */
  color?: string | null;
  /**
   * Additional CSS classes
   *
   * @optional
   */
  className?: string;
}

/** The small color square that stands for a product category next to its name. */
export function ProductCategoryColorSquare({ color, className }: ProductCategoryColorSquareProps) {
  return (
    <span
      className={cx('h-5 w-5 shrink-0', className)}
      style={{ backgroundColor: color ?? FALLBACK_COLOR }}
      aria-hidden
    />
  );
}
